export default __webpack_public_path__ + "66bda785db47b2683fe8a1611fba354a.svg";